import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface ConfirmYesNoDialogData {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'calsoft-confirm-yes-no-dialog',
  templateUrl: './confirm-yes-no-dialog.component.html',
  styleUrls: ['./confirm-yes-no-dialog.component.scss']
})
export class ConfirmYesNoDialogComponent implements OnDestroy {


  url = '';
  sanitizedUrl = '';

  constructor(
    private dialogRef: MatDialogRef<ConfirmYesNoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmYesNoDialogData, private router: Router
  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
